import { Capacitor } from '@capacitor/core'
import { SecureStorage } from '@aparajita/capacitor-secure-storage'

const memory = new Map<string, string>()
const isNative = Capacitor.isNativePlatform()

export const authStorage = {
  setItem(key: string, value: string) {
    if (!isNative) return localStorage.setItem(key, value)
    memory.set(key, value)
    void SecureStorage.set(key, value)
  },
  getItem(key: string) {
    if (!isNative) return localStorage.getItem(key)
    return memory.get(key) ?? null
  },
  removeItem(key: string) {
    if (!isNative) return localStorage.removeItem(key)
    memory.delete(key)
    void SecureStorage.remove(key)
  },
  clear() {
    if (!isNative) return localStorage.clear()
    memory.clear()
    void SecureStorage.clear()
  },
}

export const hydrateNativeAuthStorage = async () => {
  if (!isNative) return
  await SecureStorage.setKeyPrefix('yowo_auth_')
  const keys = await SecureStorage.keys()
  await Promise.all(keys.map(async (key) => {
    const value = await SecureStorage.get(key)
    if (typeof value === 'string') memory.set(key, value)
  }))
}
